import { omit } from 'lodash';
import { EVENTS_MAPPING, tracker } from '@fiverr-private/listing_lib';
import type { ActiveSideFiltersType } from '@fiverr-private/listing_types';
import { ALL_SUBCATEGORY } from '../../../../../../../lib/utils/side_filters/constants';
import { filterNavigation } from '../../../../../service/clientNavigation';
import { TOP_GROUPING } from '../../../../../config/filters';
import { BI_SOURCES } from '../../../../../utils/constants';
import type { CategoryOption } from '../FilterRow.types';

export const CATEGORIES_MENU_ID = 'leaf_category';

const TRACKING_LOCATION = 'Top Filter';

type CategoriesMenuChange = Record<string, string | undefined>;

export const navigateToCategory = (option: CategoryOption, activeFilters: ActiveSideFiltersType, source: string) => {
    const { alias, params } = option;

    tracker.trackLeafCategoryFilter(EVENTS_MAPPING.FILTERS_APPLY, {
        location: TRACKING_LOCATION,
        alias,
        id: params.nested_sub_category || params.sub_category,
    });

    filterNavigation({}, omit(activeFilters, CATEGORIES_MENU_ID), null, source, TOP_GROUPING.CATEGORY, params, {}, {});
};

export const buildCategoriesNavigation = (options: CategoryOption[], activeFilters: ActiveSideFiltersType) => {
    const selectedId = options.find(({ selected }) => selected)?.id ?? ALL_SUBCATEGORY;
    const getChangedId = (change: CategoriesMenuChange = {}) => change[CATEGORIES_MENU_ID] || ALL_SUBCATEGORY;

    return {
        navigationCondition: (change?: CategoriesMenuChange) => getChangedId(change) !== selectedId,
        applyNavigation: (change?: CategoriesMenuChange) => {
            const option = options.find(({ id }) => id === getChangedId(change));

            if (option) {
                navigateToCategory(option, activeFilters, BI_SOURCES.DROPDOWN_FILTERS);
            }
        },
    };
};
